module.exports = __webpack_public_path__ + "static/media/BS_O_Fashion_Necchi_blue_orange.c02e70e6.png";